
import { useState } from 'react';
import Card from '../../../components/base/Card';
import Button from '../../../components/base/Button';

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    service: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formElement = e.target as HTMLFormElement;
      const formDataToSend = new FormData(formElement);
      
      const response = await fetch('https://formsubmit.co/arua@crop-labs.com', {
        method: 'POST',
        body: formDataToSend
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          company: '',
          phone: '',
          service: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contato" className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-gilroy font-bold text-crop-black mb-6">
            Entre em Contato
          </h2>
          <p className="text-xl font-gilroy text-crop-dark max-w-2xl mx-auto">
            Solicite um orçamento personalizado ou tire suas dúvidas sobre nossos serviços de identificação molecular
          </p>
        </div>

        <Card className="p-8">
          <form id="contact-form" onSubmit={handleSubmit} className="space-y-6">
            <input type="hidden" name="_to" value="arua@crop-labs.com" />
            <input type="hidden" name="_subject" value="Nova solicitação - Linha Barcode®" />
            <input type="hidden" name="_captcha" value="false" />
            
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="name" className="block font-gilroy font-semibold text-crop-black mb-2">
                  Nome Completo *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 font-gilroy text-sm bg-crop-white border border-crop-teal/20 rounded-xl focus:outline-none focus:ring-2 focus:ring-crop-teal/50 focus:border-crop-teal transition-colors"
                  placeholder="Seu nome completo"
                />
              </div>

              <div>
                <label htmlFor="email" className="block font-gilroy font-semibold text-crop-black mb-2">
                  E-mail *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 font-gilroy text-sm bg-crop-white border border-crop-teal/20 rounded-xl focus:outline-none focus:ring-2 focus:ring-crop-teal/50 focus:border-crop-teal transition-colors"
                  placeholder="seu@email.com"
                />
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="company" className="block font-gilroy font-semibold text-crop-black mb-2">
                  Empresa
                </label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  className="w-full px-4 py-3 font-gilroy text-sm bg-crop-white border border-crop-teal/20 rounded-xl focus:outline-none focus:ring-2 focus:ring-crop-teal/50 focus:border-crop-teal transition-colors"
                  placeholder="Nome da sua empresa"
                />
              </div>

              <div>
                <label htmlFor="phone" className="block font-gilroy font-semibold text-crop-black mb-2">
                  Telefone
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-4 py-3 font-gilroy text-sm bg-crop-white border border-crop-teal/20 rounded-xl focus:outline-none focus:ring-2 focus:ring-crop-teal/50 focus:border-crop-teal transition-colors"
                  placeholder="(11) 99999-9999"
                />
              </div>
            </div>

            <div>
              <label htmlFor="service" className="block font-gilroy font-semibold text-crop-black mb-2">
                Serviço de Interesse
              </label>
              <div className="relative">
                <select
                  id="service"
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  className="w-full px-4 py-3 pr-8 font-gilroy text-sm bg-crop-white border border-crop-teal/20 rounded-xl focus:outline-none focus:ring-2 focus:ring-crop-teal/50 focus:border-crop-teal transition-colors appearance-none cursor-pointer"
                >
                  <option value="">Selecione um serviço</option>
                  <option value="barcode">Barcode® - Identificação padrão</option>
                  <option value="barcode-pro">Barcode® Pro - Identificação avançada</option>
                  <option value="barcode-meta">Barcode® Meta - Análise metagenômica</option>
                  <option value="consultoria">Consultoria técnica</option>
                  <option value="outros">Outros serviços</option>
                </select>
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                  <i className="ri-arrow-down-s-line text-crop-dark"></i>
                </div>
              </div>
            </div>

            <div>
              <label htmlFor="message" className="block font-gilroy font-semibold text-crop-black mb-2">
                Mensagem *
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                maxLength={500}
                rows={5}
                className="w-full px-4 py-3 font-gilroy text-sm bg-crop-white border border-crop-teal/20 rounded-xl focus:outline-none focus:ring-2 focus:ring-crop-teal/50 focus:border-crop-teal transition-colors resize-none"
                placeholder="Descreva sua necessidade ou dúvida sobre nossos serviços..."
              />
              <p className="text-sm font-gilroy text-crop-dark mt-2">
                {formData.message.length}/500 caracteres
              </p>
            </div>

            {submitStatus === 'success' && (
              <div className="p-4 bg-green-50 border border-green-200 rounded-xl">
                <p className="font-gilroy text-green-800">
                  Mensagem enviada com sucesso! Entraremos em contato em breve.
                </p>
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="p-4 bg-red-50 border border-red-200 rounded-xl">
                <p className="font-gilroy text-red-800">
                  Erro ao enviar mensagem. Tente novamente ou entre em contato diretamente.
                </p>
              </div>
            )}

            <Button 
              type="submit" 
              size="lg" 
              disabled={isSubmitting}
              className="w-full whitespace-nowrap"
            >
              {isSubmitting ? 'Enviando...' : 'Enviar Mensagem'}
            </Button>
          </form>
        </Card>
      </div>
    </section>
  );
}
